import request from '@/utils/axios.js'

// 按活动id获取关联的优惠券列表
export function listCoupon (data) {
  return request({
    url: '/manageMarket/mobileAPI/coupons/coupon-list',
    method: 'post',
    data: data
  })
}

// 领劵
export function getItemCoupon (data) {
  return request({
    url: '/manageMarket/mobileAPI/coupons/grant',
    method: 'post',
    data: data
  })
}
